import React from "react";
import FormModel from "../../../../../../core/gd-form/common/form-model-manager";
import ErrorBoundary from "../../../../../../core/error-boundary";
import FormFlex from "../../../../../../core/gd-form/form/form-flex/form";
import FieldFormElement from "../../../../../../core/fields3/render/form-elemnent";
import ReportFields from "../../../../../../core/model2/report/fields";
import FormRowFlex from "../../../../../../core/gd-form/form/form-flex/row";
import FormFieldError from "../../../../../../core/gd-form/common/form-error/form-field-error";
import ButtonSubmit from "../../../../../../core/gd-form/common/btn-submit/btn-submit-ui5-new";
import Report from "../../../../../../core/model2/report/report";

type Props = {
    report      : Report
    onSubmit    : callback
}

export default class NewReportForm extends React.Component<Props>{

    public form  : FormModel

    public report : Report

    public fields: ReportFields = new ReportFields()

    constructor(props: Props) {
        super(props);

        this.report = this.props.report

        this.form  = new FormModel(this.report, {
            // Create report here!!!
            onSubmit: ()=> {
                return this.props.onSubmit(this.report)
            }
        })
    }

    render(){


        return (
            <ErrorBoundary>
                <div className="iv-content">
                    <div className="p-l-30">
                        <FormFlex className="m-t-40 m-l-20">
                            <FormRowFlex width={150} label="Name" field={this.fields.name} form={this.form}>
                                <FieldFormElement form={this.form}
                                                  field={this.fields.name}
                                                  model={this.report}
                                                  className="w-300"/>
                                <FormFieldError form={this.form} field={this.fields.name} className="w-200"/>
                            </FormRowFlex>

                            <FormRowFlex width={150} form={this.form}>
                                <ButtonSubmit form={this.form} className="submit w-100" label="Submit"/>
                            </FormRowFlex>
                        </FormFlex>
                    </div>
                </div>
            </ErrorBoundary>
        )
    }
}
